import { MailRowDataPropertyGetter, getSelectedItemParts, getSelectedTableView } from "owa-mail-list-store";
import { isFirstLevelExpanded } from "owa-mail-list-store/lib/selectors/isConversationExpanded";
import getEffectiveRowKeys from "owa-mail-list-store/lib/utils/getEffectiveRowKeys";
import { getMailboxInfo } from "owa-mail-mailboxinfo";
import { isReadingPaneStackedView } from "owa-mail-organization-settings/lib/utils/readingPaneStackedViewUtils";
import getItemForMailList from "owa-mail-store/lib/selectors/getItemForMailList";
import { getStore as getMailStore } from "owa-mail-store/lib/store/Store";
import { isScheduleWithCopilotSupportedForItem } from "owa-meeting-message-utils/lib/utils/isScheduleWithCopilotSupportedForItem";
import type Item from "owa-service/lib/contract/Item";

/**
 * Whether "Schedule with Copilot" is supported for the item the main window reply with meeting
 * command acts on. The target item is resolved the same way onResponse resolves it. Returns true
 * when there is no single target item so callers keep their existing behavior.
 */
export function isScheduleWithCopilotSupportedForSelectedItem(): boolean {
    const tableView = getSelectedTableView(true /* shouldGetEffectiveTableView */);
    if (!tableView) {
        return true;
    }
    
    const rowKeys = getEffectiveRowKeys(tableView);
    if (rowKeys.length !== 1) {
        return true;
    }
    
    const rowKey = rowKeys[0];
    const selectedItemParts = getSelectedItemParts();
    let item: Item | null | undefined;
    if (selectedItemParts.length === 1) {
        item = getItemForMailList(selectedItemParts[0], isFirstLevelExpanded(rowKey));
    }
    else if (!isReadingPaneStackedView(tableView.tableQuery.listViewType)) {
        const rowId = MailRowDataPropertyGetter.getRowIdToShowInReadingPane(rowKey, tableView);
        item = rowId ? getMailStore().items.get(rowId.Id) : undefined;
    }
    else {
        // The command targets the latest non-draft item of the conversation, which is resolved
        // asynchronously. replyByMeeting falls back to the non-Copilot experience if needed.
        return true;
    }
    
    return isScheduleWithCopilotSupportedForItem(item ?? undefined, getMailboxInfo(tableView));
}
